module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/1@2x_29aa8d4ca93378c5e1ef09234e6322dc.png";